import { CheckIcon } from './Icons';

export function InterestCheck({
  checked,
  label,
  onToggle,
  chip = false,
}: {
  checked: boolean;
  label: string;
  onToggle: () => void;
  chip?: boolean;
}) {
  const on = checked ? ' interest-chip--on' : '';
  const compact = chip ? '' : ' interest-chip--compact';
  return (
    <button
      type="button"
      className={`interest-chip${compact}${on}`}
      aria-pressed={checked}
      aria-label={checked ? `Remove ${label} from Favorites` : `Add ${label} to Favorites`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onToggle();
      }}
    >
      <CheckIcon checked={checked} />
      {chip ? <span>{label}</span> : null}
    </button>
  );
}
